// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8d65637e","76":"7c466f49","189":"bb3d405f","212":"4f816635","882":"c9ef8dfd","968":"f231dce6"}[chunkId] + ".chunk.css";
};